import React from "react";
import { Stage, StageProps } from "app/stage/Stage/Stage";
import { chartPeriods } from "app/charts/types";
import { useChartData } from "app/charts/hooks";

type contentFunction = (period: chartPeriods, chartData?: [number, number][]) => React.ReactNode;

interface StageContainerProps extends Omit<StageProps, "chartData" | "selectedPeriod"> {
    chartKey?: string | null;
    defaultPeriod?: chartPeriods;
    performanceByPeriods?: { [key in chartPeriods]: number };
    children: React.ReactNode | contentFunction;
}

export const StageContainer = (props: StageContainerProps) => {
    const { performanceByPeriods } = props;

    const [period, setPeriod] = React.useState<chartPeriods>(props.defaultPeriod || chartPeriods.INTRADAY);
    const [[chartData, performance, exchangeOpen], loading, error] = useChartData(props.chartKey || "", period);

    let headPerformance = performance;
    if (performanceByPeriods && performanceByPeriods[period]) {
        headPerformance = performanceByPeriods[period];
    }

    const childResult = typeof props.children === "function" ? props.children(period, chartData) : props.children;

    return (
        <Stage
            headValue={props.headValue}
            headCurrency={props.headCurrency}
            headPerformance={headPerformance}
            headInfoItems={props.headInfoItems}
            noIntraday={props.noIntraday}
            chartData={chartData}
            selectedPeriod={period}
            onPeriodChange={setPeriod}
            loading={loading}
            chartError={error}
            todayExchangeOpen={exchangeOpen}
            lastExchangeClose={props.lastExchangeClose}
            lastExchangeCloseValue={props.lastExchangeCloseValue}
        >
            {childResult}
        </Stage>
    );
};
